import axios from "axios";

import defaultConfig from "../config/default";

const api = axios.create({
  baseURL: defaultConfig.baseApi,
});

export default api;
